// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DropdownFiltersCancelRequest_wrapper__2IHYW","filter":"DropdownFiltersCancelRequest_filter__6G4Dv","alternatives":"DropdownFiltersCancelRequest_alternatives__2_7Ei"};